import { getCurrencySymbol } from '../utils/currencyUtil';
import { useConfig } from '../context/ConfigContext';
import { POS_DELIVERY_FEE_MAX } from '../constants/posConst';
import '../css/Pos.css';

/**
 * "With delivery fee" on the order confirmation: a checkbox, and the amount
 * once it is ticked.
 *
 * Holds no state of its own — the confirmation owns both values, because the
 * fee changes the total it quotes, the change it works out and the order it
 * records.
 *
 * @param {object} props
 * @param {boolean} props.checked - whether a delivery fee applies
 * @param {(checked: boolean) => void} props.onCheckedChange
 * @param {string} props.fee - the amount as typed
 * @param {(fee: string) => void} props.onFeeChange
 * @param {boolean} [props.disabled]
 * @returns {JSX.Element}
 */
function PosDeliveryFeeField({ checked, onCheckedChange, fee, onFeeChange, disabled = false }) {
  const { config } = useConfig();
  const amount = Number(fee);
  const invalid = checked && fee !== '' && (!Number.isFinite(amount) || amount < 0 || amount > POS_DELIVERY_FEE_MAX);

  return (
    <div className="pos-delivery">
      <label className="pos-check pos-delivery-check">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onCheckedChange(e.target.checked)}
          disabled={disabled}
        />
        <span><strong>With delivery fee</strong></span>
      </label>

      {checked && (
        <label className="pos-field pos-delivery-field">
          <span>Delivery fee ({getCurrencySymbol(config)})</span>
          <input
            type="number"
            min="0"
            max={POS_DELIVERY_FEE_MAX}
            step="0.01"
            inputMode="decimal"
            value={fee}
            onChange={(e) => onFeeChange(e.target.value)}
            placeholder="0"
            disabled={disabled}
            className={invalid ? 'pos-theme-bad' : ''}
            /* eslint-disable-next-line jsx-a11y/no-autofocus */
            autoFocus
          />
          {invalid && (
            <span className="pos-theme-bad-note">
              Enter an amount between 0 and {POS_DELIVERY_FEE_MAX}.
            </span>
          )}
          <span className="pos-theme-hint">Added to the total amount the customer pays.</span>
        </label>
      )}
    </div>
  );
}

export default PosDeliveryFeeField;
